import { useTradesColumnStore } from '@/stores';
import { useTradesCrossDnd, addSidebarPrefix } from './TradesCrossDndContext';
import { createColumnManagerPanel } from '@/components/shared/createColumnManagerPanel';
import type { CreateColumnManagerPanelConfig } from '@/components/shared/createColumnManagerPanel';

export const TradesColumnManagerPanel = createColumnManagerPanel({
  useColumnStore: useTradesColumnStore as CreateColumnManagerPanelConfig['useColumnStore'],
  useCrossDnd: useTradesCrossDnd,
  addSidebarPrefix,
});
